var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "135px",
    height: "40px",
    viewBox: "0 0 135 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google-play-badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.9903275%",
    y1: "4.94615078%",
    x2: "26.5360307%",
    y2: "71.8787395%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.684729%",
    y1: "50%",
    x2: "-130.640394%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500",
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.2709832%",
    y1: "30.8725537%",
    x2: "-50.1798561%",
    y2: "136.108936%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.82494%",
    y1: "-11.9103989%",
    x2: "42.0863309%",
    y2: "35.0790955%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-play-badge",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 0,
    y: 0,
    width: 135,
    height: 40,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,0.8 C132.319596,0.8 134.2,2.68040405 134.2,5 L134.2,35 C134.2,37.3195959 132.319596,39.2 130,39.2 L5,39.2 C2.68040405,39.2 0.8,37.3195959 0.8,35 L0.8,5 C0.8,2.68040405 2.68040405,0.8 5,0.8 L130,0.8 M130,0 L5,0 C2.23857625,0 0,2.23857625 0,5 L0,35 C0,37.7614237 2.23857625,40 5,40 L130,40 C132.761424,40 135,37.7614237 135,35 L135,5 C135,2.23857625 132.761424,0 130,0 Z",
    id: "Shape",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.42,10.24 C47.4531747,10.9810449 47.182257,11.703492 46.67,12.24 C46.0954216,12.8332072 45.2951824,13.1533029 44.47,13.12 C43.6405789,13.1384846 42.840533,12.812674 42.26,12.22 C41.6610798,11.6387903 41.3313371,10.8343631 41.35,10 C41.3285284,9.16218871 41.658494,8.35359175 42.26,7.77 C43.1709107,6.87991481 44.5271184,6.62365464 45.7,7.12 C46.0606018,7.26823045 46.3822404,7.49748348 46.64,7.79 L46.11,8.32 C45.7073541,7.83495058 45.0995877,7.56812631 44.47,7.6 C43.8388494,7.59690387 43.2336793,7.85108766 42.794036,8.30393914 C42.3543927,8.75679062 42.1182283,9.36921739 42.14,10 C42.1266019,10.9531897 42.6879765,11.8208395 43.5629333,12.1992583 C44.43789,12.5776771 45.4545926,12.3925456 46.14,11.73 C46.4483532,11.3960734 46.6289602,10.964033 46.65,10.51 L44.47,10.51 L44.47,9.79 L47.38,9.79 C47.4023649,9.9390598 47.4157225,10.0893324 47.42,10.24 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "52 7.74 49.3 7.74 49.3 9.64 51.76 9.64 51.76 10.36 49.3 10.36 49.3 12.26 52 12.26 52 13 48.52 13 48.52 7 52 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "55.28 13 54.51 13 54.51 7.74 52.83 7.74 52.83 7 57 7 57 7.74 55.28 7.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "59.94 13 59.94 7 60.71 7 60.71 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "64.13 13 63.36 13 63.36 7.74 61.68 7.74 61.68 7 65.8 7 65.8 7.74 64.13 7.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.61,12.22 C73.026689,12.8037876 72.2352634,13.1317962 71.41,13.1317962 C70.5847366,13.1317962 69.793311,12.8037876 69.21,12.22 C68.6220886,11.6336659 68.3034763,10.8298939 68.33,10 C68.3034763,9.1701061 68.6220886,8.36633406 69.21,7.78 C69.7814921,7.17897422 70.5809257,6.84829942 71.41,6.87 C72.2374575,6.85691055 73.0335694,7.18621139 73.61,7.78 C74.190918,8.37091188 74.5082932,9.17156292 74.49,10 C74.5165237,10.8298939 74.1979114,11.6336659 73.61,12.22 L73.61,12.22 Z M69.78,11.72 C70.2103002,12.1560579 70.7973788,12.4015225 71.41,12.4015225 C72.0226212,12.4015225 72.6096998,12.1560579 73.04,11.72 C73.487588,11.2614073 73.7294458,10.6405186 73.71,10 C73.7188876,9.35362401 73.4622445,8.73189704 73,8.28 C72.5696998,7.84394215 71.9826212,7.59847754 71.37,7.59847754 C70.7573788,7.59847754 70.1703002,7.84394215 69.74,8.28 C69.3069897,8.74512822 69.0798596,9.3652294 69.11,10 C69.0905542,10.6405186 69.332412,11.2614073 69.78,11.72 L69.78,11.72 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "75.58 13 75.58 7 76.51 7 79.43 11.67 79.43 11.67 79.43 10.51 79.43 7 80.2 7 80.2 13 79.4 13 76.35 8.11 76.35 8.11 76.35 9.26 76.35 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.14,21.75 C65.7872765,21.7555293 63.8844985,23.6672686 63.8900115,26.0199921 C63.8955484,28.3727156 65.8072843,30.2754972 68.1600078,30.2699885 C70.5127313,30.2644558 72.4155163,28.3527235 72.41,26 C72.426473,24.8643738 71.9812316,23.7707097 71.1762551,22.9695037 C70.3712787,22.1682976 69.2755364,21.7281956 68.14,21.75 Z M68.14,28.58 C67.0832273,28.6539053 66.088673,28.0743135 65.6320213,27.1184371 C65.1753697,26.1625607 65.3494358,25.0246828 66.0709659,24.249038 C66.7924959,23.4733932 67.9148379,23.2176324 68.9011878,23.6040831 C69.8875378,23.9905338 70.5374189,24.9406494 70.54,26 C70.5725428,26.6626719 70.3360327,27.3103928 69.8841403,27.7961771 C69.432248,28.2819613 68.8032921,28.5646164 68.14,28.58 Z M58.82,21.75 C56.4672765,21.7555293 54.5644985,23.6672686 54.5700115,26.0199921 C54.5755484,28.3727156 56.4872843,30.2754972 58.8400078,30.2699885 C61.1927313,30.2644558 63.0955163,28.3527235 63.09,26 C63.106473,24.8643738 62.6612316,23.7707097 61.8562551,22.9695037 C61.0512787,22.1682976 59.9555364,21.7281956 58.82,21.75 Z M58.82,28.58 C57.7632273,28.6539053 56.768673,28.0743135 56.3120213,27.1184371 C55.8553697,26.1625607 56.0294358,25.0246828 56.7509659,24.249038 C57.4724959,23.4733932 58.5948379,23.2176324 59.5811878,23.6040831 C60.5675378,23.9905338 61.2174189,24.9406494 61.22,26 C61.2525428,26.6626719 61.0160327,27.3103928 60.5641403,27.7961771 C60.112248,28.2819613 59.4832921,28.5646164 58.82,28.58 Z M47.74,23.06 L47.74,24.86 L52.06,24.86 C51.9922634,25.7078038 51.6398446,26.5077945 51.06,27.13 C50.1836518,28.0228625 48.9699725,28.5025202 47.72,28.45 C45.0690332,28.45 42.92,26.3009668 42.92,23.65 C42.92,20.9990332 45.0690332,18.85 47.72,18.85 C48.9404476,18.8318498 50.1188954,19.2953247 51,20.14 L52.27,18.87 C51.0659807,17.6791542 49.4332385,17.0231739 47.74,17.05 C45.3189608,16.955779 43.0403936,18.1936718 41.801854,20.2760571 C40.5633145,22.3584423 40.5633145,24.9515577 41.801854,27.0339429 C43.0403936,29.1163282 45.3189608,30.354221 47.74,30.26 C49.4701987,30.3291046 51.1475475,29.655982 52.35,28.41 C53.4001185,27.2564101 53.9596631,25.7391832 53.91,24.18 C53.9135793,23.8047255 53.8834584,23.4298875 53.82,23.06 L47.74,23.06 Z M93.05,24.46 C92.5160796,22.8892101 91.0679278,21.811053 89.41,21.7499923 C88.3043635,21.7478383 87.2471451,22.2034076 86.4893794,23.0085336 C85.7316138,23.8136596 85.3408955,24.8965231 85.41,26 C85.3924407,27.8748194 86.611123,29.5374987 88.4042599,30.0851449 C90.1973968,30.632791 92.1370825,29.9347165 93.17,28.37 L91.72,27.37 C91.280167,28.103094 90.4848748,28.5483054 89.63,28.54 C88.742835,28.5766297 87.9244125,28.0641224 87.57,27.2499923 L93.26,24.9 L93.05,24.46 Z M87.25,25.88 C87.2090571,25.2525116 87.4223869,24.634951 87.8419025,24.1665232 C88.2614182,23.6980954 88.8518111,23.4182257 89.48,23.39 C90.1387659,23.3497893 90.7574492,23.7083892 91.05,24.3 L87.25,25.88 Z M82.63,30 L84.5,30 L84.5,17.5 L82.63,17.5 L82.63,30 Z M79.57,22.7 L79.5,22.7 C78.9255491,22.0747262 78.1088181,21.7283448 77.26,21.75 C74.9901469,21.8600717 73.2063371,23.7324796 73.2063371,26.005 C73.2063371,28.2775204 74.9901469,30.1499283 77.26,30.26 C78.1183976,30.2772187 78.9397171,29.9105582 79.5,29.26 L79.57,29.26 L79.57,29.87 C79.57,31.5 78.7,32.37 77.3,32.37 C76.3435146,32.3489876 75.4943492,31.752597 75.15,30.86 L73.53,31.53 C74.1431493,33.0699895 75.6425851,34.0722649 77.3,34.05 C79.49,34.05 81.3,32.76 81.3,29.62 L81.3,22 L79.57,22 L79.57,22.7 Z M77.42,28.58 C76.0600866,28.4952122 75.0005459,27.367554 75.0005459,26.005 C75.0005459,24.642446 76.0600866,23.5147878 77.42,23.43 C78.0670204,23.4579218 78.6750106,23.747221 79.1047995,24.231676 C79.5345883,24.7161309 79.7493771,25.3542625 79.7,26 C79.7551348,26.6480494 79.5426575,27.2904311 79.1119703,27.7777877 C78.6812831,28.2651443 78.0699104,28.5550138 77.42,28.58 L77.42,28.58 Z M101.81,17.5 L97.33,17.5 L97.33,30 L99.2,30 L99.2,25.26 L101.81,25.26 C103.262684,25.3643638 104.651974,24.648509 105.41013,23.404973 C106.168286,22.161437 106.168286,20.598563 105.41013,19.355027 C104.651974,18.111491 103.262684,17.3956362 101.81,17.5 L101.81,17.5 Z M101.81,23.5 L99.2,23.5 L99.2,19.24 L101.85,19.24 C103.031889,19.24 103.99,20.1981106 103.99,21.38 C103.99,22.5618894 103.031889,23.52 101.85,23.52 L101.81,23.5 Z M113.35,21.71 C111.958089,21.6241747 110.648702,22.3752042 110.02,23.62 L111.67,24.31 C112.010603,23.695923 112.680401,23.3394806 113.38,23.4 C113.859528,23.3439946 114.341454,23.4829701 114.717528,23.7857102 C115.093603,24.0884503 115.332299,24.5295749 115.38,25.01 L115.38,25.13 C114.778663,24.8139168 114.109348,24.6491623 113.43,24.65 C111.65,24.65 109.83,25.65 109.83,27.47 C109.865569,28.2515813 110.216509,28.9853449 110.802624,29.5036142 C111.38874,30.0218835 112.159942,30.280368 112.94,30.22 C113.895412,30.2728479 114.805111,29.8065317 115.32,29 L115.38,29 L115.38,30 L117.18,30 L117.18,25.19 C117.18,23 115.52,21.73 113.39,21.73 L113.35,21.71 Z M113.12,28.56 C112.51,28.56 111.66,28.25 111.66,27.5 C111.66,26.5 112.72,26.16 113.66,26.16 C114.254042,26.1453419 114.841131,26.2903874 115.36,26.58 C115.230157,27.7031043 114.29036,28.5574651 113.16,28.58 L113.12,28.56 Z M123.74,22 L121.6,27.42 L121.54,27.42 L119.32,22 L117.32,22 L120.65,29.58 L118.75,33.79 L120.75,33.79 L125.82,22 L123.74,22 Z M106.94,30 L108.8,30 L108.8,17.5 L106.94,17.5 L106.94,30 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44,7.54 C10.1212366,7.93405554 9.96397325,8.434439 10,8.94 L10,31.06 C9.96597397,31.5703792 10.1348935,32.0735438 10.47,32.46 L10.54,32.54 L22.9,20.15 L22.9,19.85 L10.51,7.47 L10.44,7.54 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,24.28 L22.9,20.15 L22.9,19.85 L27,15.72 L27.09,15.78 L32,18.56 C33.4,19.35 33.4,20.65 32,21.45 L27.11,24.23 L27,24.28 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.12,24.22 L22.9,20 L10.44,32.46 C11.0230326,32.9789708 11.89324,33.0083981 12.51,32.53 L27.12,24.22",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.12,15.78 L12.51,7.48 C11.8969646,6.9947215 11.0238977,7.02002779 10.44,7.54 L22.9,20 L27.12,15.78 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,24.13 L12.51,32.38 C11.9181542,32.8266792 11.1018458,32.8266792 10.51,32.38 L10.51,32.38 L10.44,32.45 L10.44,32.45 L10.51,32.53 L10.51,32.53 C11.1018458,32.9766792 11.9181542,32.9766792 12.51,32.53 L27.12,24.22 L27,24.13 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44,32.32 C10.1187941,31.9233599 9.96138192,31.4189256 10,30.91 L10,31.06 C9.96597397,31.5703792 10.1348935,32.0735438 10.47,32.46 L10.54,32.39 L10.44,32.32 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,21.3 L27,24.13 L27.09,24.22 L32,21.44 C32.5903954,21.1903582 32.9970603,20.6379078 33.06,20 L33.06,20 C32.9332082,20.5771002 32.5397617,21.059629 32,21.3 L32,21.3 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.51,7.62 L32,18.7 C32.5397617,18.940371 32.9332082,19.4228998 33.06,20 L33.06,20 C32.9970603,19.3620922 32.5903954,18.8096418 32,18.56 L12.51,7.48 C11.12,6.68 10,7.34 10,8.94 L10,9.09 C10,7.49 11.12,6.83 12.51,7.62 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.25
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.80c6b77437c3a48830db592ae68caa4f.svg";
export { ForwardRef as ReactComponent };